import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { useContext, useState } from "react";
import { Login } from "../../../../services/LoginService";
import LoginModel from "../../../../models/Login";
import { AuthenticationContext } from "../../../controls/auth/AuthenticationWrap";

export default function useLogin(props: {
	setOpenDialog?: (value: boolean) => void;
	setLoading?: (value: boolean) => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const [dataLogin, setDataLogin] = useState<LoginModel>();
	const [errorMess, setErrorMess] = useState("");
	// const backPath = getBackPath(search);
	const authCtx = useContext(AuthenticationContext);
	const { onLoginSuccess } = authCtx || {};
	const doLogin = async (email: string, password: string) => {
		try {
			let res = await Login(email, password);
			onLoginSuccess?.(res);
			props.setLoading?.(false);
			props.setOpenDialog?.(false);
		} catch (error: any) {
			openAlertDialog?.(AlertType.Fail, error?.response?.data?.message || "An error has occurred!", () => {
				props.setLoading?.(false);
			});
			setErrorMess(error?.response?.data?.message || "An error has occurred!");
		} finally {
		}
	};

	return {
		doLogin,
		dataLogin,
		errorMess,
	};
}
